import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=6a3f9cca&scoped=true"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"
import style0 from "./ForgotPassword.vue?vue&type=style&index=0&id=6a3f9cca&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3f9cca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a3f9cca')) {
      api.createRecord('6a3f9cca', component.options)
    } else {
      api.reload('6a3f9cca', component.options)
    }
    module.hot.accept("./ForgotPassword.vue?vue&type=template&id=6a3f9cca&scoped=true", function () {
      api.rerender('6a3f9cca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/ForgotPassword.vue"
export default component.exports